module.exports = __webpack_public_path__ + "img/Czech-Republic.df0a5781.png";